export enum AdminTeamsRoutes {
  CreateTeam = 'create-team',
  GetTeams = 'get-teams',
  ImportStatsApiHitters = 'import-stats-api-hitters', // after enabling hitter import from hitter library, trigger an import right away
  UpdateTeam = 'update-team',
  GetTeamHitters = 'get-team-hitters', // get all hitters for a team
}
